import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'flag-2', 'Flag2', [["path",{"d":"M5 14h14v-9h-14v16","key":"svg-0"}]]);